module.exports = __webpack_public_path__ + "img/mapBg.0c429ead.png";